/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

import template from './viewability-targeting.component.html';
import {ADN_TARGETING_TYPES} from '../targeting-constants';
import {TargetingTemplateHook} from './targeting-template.component';

@Component({
  standalone: false,
  selector: 'adn-viewability-targeting',
  template
})
export class ViewabilityTargetingComponent implements OnInit {
  @Input() model: any;
  @Input() tabController: any;
  @Input() overridableTargeting: any;
  @Input() targetType: any = ADN_TARGETING_TYPES.viewability;
  @Input() underModel: any;
  @Input() mode: string;
  @Input() isLockedDown: boolean;
  @Input() mandatory: boolean;

  readonly templateHook: TargetingTemplateHook = {
    getTemplateData: () => {
      this.prepareForSave();
      const model = this.model || {};
      return {
        vm: _.cloneDeep(model),
        model: _.cloneDeep(model),
        constant: ADN_TARGETING_TYPES.viewability,
        summary: _.isFinite(model.viewability) ? model.viewability + '%' : ''
      };
    },
    copyTemplate: (tpl: any) => {
      if (!this.model) {
        return;
      }
      const copied = _.cloneDeep(_.get(tpl, ['data', 'model'])) || {};
      Object.keys(this.model).forEach((key) => delete this.model[key]);
      Object.assign(this.model, copied);
    }
  };

  ngOnInit(): void {
    this.prepareForSave();

    if (!this.tabController) {
      return;
    }

    const prepareForSave = () => this.prepareForSave();
    const copyTemplate = (tpl: any) => this.templateHook.copyTemplate(tpl);
    this.tabController.register(ADN_TARGETING_TYPES.viewability.widget, prepareForSave, copyTemplate);
    this.tabController.callBeforeSubmit(prepareForSave);
    this.tabController.registerAllTabs(prepareForSave);
  }

  private prepareForSave(): void {
    if (!this.model) {
      return;
    }
    if (!_.isFinite(this.model.viewability) || this.model.viewability <= 0 || this.model.viewability > 100) {
      this.model.viewability = null;
    }
  }
}
